<template>
  <div class="home-wrapper" ref="homeWrapper">
    <Banner class="banner" @showActivityDetail="handleShowActivityDetail" />
    <div class="search-tab" :class="isTop ? 'top' : ''" ref="searchTab">
      <SearchBar :isTop="isTop" @search="handleSearch" @refreshSearch="handleRefreshSearch" ref="home_search_bar" />
      <WorkTab
        @toggleMenu="handleToggleMenu"
        @showMask="handleShowMask"
        @closeMask="handleCloseMask"
        ref="workTab"
        @selArea="handleSelArea"
        @selActivity="handleSelActivity"
        @selWorksType="handleSelWorksType"
      />
      <div class="mask transparent" v-show="showMask" @click.self="handleClosePicker"></div>
    </div>
    <template v-if="showNoWorkData">
      <NoWorksData v-show="showNoWorkData" :noDataText="noDataText" />
    </template>
    <template v-else>
      <ReportWork />
      <BottomLoading :showNoMore="noMoreWorkList" />
    </template>
    <transition name="fade">
      <div class="mask" v-show="showMask" @click.self="handleClosePicker"></div>
    </transition>
    <messagebox v-model="showActivityDetail"></messagebox>
  </div>
</template>

<script>
import Banner from "./components/Banner"
import ReportWork from "./components/ReportWork"
import SearchBar from "./components/ReportWork/SearchBar"
import WorkTab from "./components/ReportWork/WorkTab"
import BottomLoading from "@/components/BottomLoading"
import NoWorksData from "@/components/NoWorksData"
import messagebox from "@/components/Messagebox/index"
import getUserInfo from "@/mixins/getUserInfo"
import setDocuemntTtitle from "@/utils/setDocumentTitle"
import { mapActions, mapGetters, mapMutations } from "vuex"
import { buryingPoint_home } from "@/server/buryingPoint"

export default {
  name: "home",
  data() {
    return {
      isTop: false,
      showMask: false,
      showActivityDetail: false,
      worksListSearchOptions: {
        page: 0,
        size: 20,
        keyword: "",
        categoryId: "",
        region: "",
        sort: "",
        typeId: ""
      },
      selectTabIndex: 0
    }
  },
  mixins: [getUserInfo],
  methods: {
    ...mapMutations({
      showLoading: "loading/showLoading",
      hideLoading: "loading/hideLoading",
      saveScrollTop: "home/saveScrollTop",
      refreshActivityBannerDesc: "activityInfo/refreshActivityBannerDesc"
    }),
    ...mapActions({
      getActivityInfo: "activityInfo/getActivityInfo",
      getWorksList: "home/getWorksList",
      initShareInfo: "activityInfo/initShareInfo"
    }),
    toggleBorderRadius(scrollEvent) {
      const target = scrollEvent.target
      const scrollTop = target.scrollTop
      const offsetTop = this.$refs.searchTab.offsetTop
      const isToTop = scrollTop === offsetTop
      this.isTop = isToTop
    },
    uploadMore(scrollEvent) {
      const target = scrollEvent.target
      const scrollTop = target.scrollTop
      const homeDom = this.$refs.homeWrapper
      const homeScrollHeight = homeDom.scrollHeight
      const homeOffsetHeight = homeDom.offsetHeight
      const isToBottom = homeOffsetHeight + scrollTop + 10 > homeScrollHeight
      isToBottom && this.handleLoadMore()
    },
    handleLoadMore() {
      // @TODO 判断是否没有跟多数据或者正在加载中，等接口一起判断
      if (!this.loadingWork && !this.noMoreWorkList) {
        this.worksListSearchOptions.page++
        this._getWorksList()
      }
    },
    handleShowMask() {
      this.showMask = true
    },
    handleCloseMask() {
      this.showMask = false
    },
    handleClosePicker() {
      this.$refs.workTab.closePicker()
      this.showMask = false
    },
    initScrollEvent() {
      this.$refs.homeWrapper.onscroll = e => {
        if (this.scrollTimer) {
          window.clearTimeout(this.scrollTimer)
          this.scrollTimer = null
        }
        this.scrollTimer = window.setTimeout(() => {
          this.toggleBorderRadius(e)
          this.uploadMore(e)
        }, 17)
      }
    },
    handlePreventTouchMove(e) {
      e.preventDefault()
    },
    handleToggleLockScroll(lock = true) {
      if (lock) {
        this.$refs.homeWrapper.addEventListener("touchmove", this.handlePreventTouchMove, { passive: false })
      } else {
        this.$refs.homeWrapper.removeEventListener("touchmove", this.handlePreventTouchMove, { passive: false })
      }
    },
    handleSearch(keyWord) {
      if (keyWord !== "") {
        this._getWorksList({ page: 0 }, true)
      }
    },
    handleRefreshSearch() {
      this._getWorksList({ page: 0 }, true)
    },
    handleToggleMenu(navKey, categoryId, item, selectTabIndex) {
      this.refreshActivityBannerDesc(item) //重刷banner图
      categoryId ? (this.worksListSearchOptions.categoryId = categoryId) : (this.worksListSearchOptions.categoryId = "")
      const isSame = selectTabIndex === this.selectTabIndex //是否重复点击tab
      this.selectTabIndex = selectTabIndex
      if (!isSame || navKey === "ACTIVITY_CATEGORY") {
        const SELECT_KEY = ["AREA", "WORKSTYPE"]
        const isSelectTab = SELECT_KEY.includes(navKey)
        this.worksListSearchOptions.sort = navKey
        if (!isSelectTab) {
          this._getWorksList({ page: 0 }, true)
        }
      }
    },
    handleSelArea(region) {
      const isSame = region === this.worksListSearchOptions.region
      if (!isSame) {
        this.worksListSearchOptions.region = region
        this.worksListSearchOptions.sort = "AREA"
        this._getWorksList({ page: 0 }, true)
      }
    },
    handleSelActivity(activityItem) {
      const activityId = activityItem.id
      const isSame = activityId === this.worksListSearchOptions.categoryId
      if (!isSame) {
        this.worksListSearchOptions.categoryId = activityId
        this.worksListSearchOptions.sort = "ACTIVITY_CATEGORY"
        this._getWorksList({ page: 0 }, true)
        this.refreshActivityBannerDesc(activityItem)
      }
      window.categoryId = activityId
    },
    handleSelWorksType(worksTypeId) {
      const isSame = worksTypeId === this.worksListSearchOptions.typeId
      if (!isSame) {
        this.worksListSearchOptions.typeId = worksTypeId
        this.worksListSearchOptions.sort = "WORKSTYPE"
        this._getWorksList({ page: 0 }, true)
      }
    },
    async _getWorksList(searchOptions = {}, showLoading = false) {
      const finalFunc = () => {
        this.loadingWork = false
      }
      const keyWord = this.$refs.home_search_bar.keyWord
      searchOptions.keyword = keyWord
      const params = {
        params: Object.assign(this.worksListSearchOptions, searchOptions),
        showLoading,
        finalFunc
      }
      this.activityCategorys.length > 0 && params.params.sort === "ACTIVITY_CATEGORY" ? (params.params.sort = "POPULARITY") : ""
      this.loadingWork = true
      await this.getWorksList(params)
    },
    handleShowActivityDetail() {
      this.showActivityDetail = true
    },
    _saveScrollTop() {
      const home = this.$refs.homeWrapper
      let scrollTop = 0
      home && (scrollTop = home.scrollTop)
      this.saveScrollTop(scrollTop)
    },
    setScrollTop() {
      const home = this.$refs.homeWrapper
      if (home && this.scrollTop) {
        home.scrollTop = this.scrollTop
      }
    },
    async init() {
      this.showLoading()
      try {
        const activityStatus = await this.getActivityInfo({ showLoading: false })
        const defaultActivity = this.activityCategorys.find(item => item.isDefault)
        if (defaultActivity) {
          this.worksListSearchOptions.categoryId = defaultActivity.id
        }
        if (activityStatus) {
          if (this.indexNavigations[0] === "ACTIVITY_CATEGORY") {
            let params = {
              sort: this.indexNavigations[0]
            }
            if (this.activityCategorys.length > 0) {
              params.categoryId = this.activityCategorys[0].id
            }
            this._getWorksList(params)
          } else {
            await this._getWorksList({ sort: this.indexNavigations[0] })
          }
        }
        setDocuemntTtitle(this.activityName)
      } catch (err) {
        window.console.error(err)
      } finally {
        this.hideLoading()
      }
    }
  },
  components: {
    Banner,
    ReportWork,
    SearchBar,
    WorkTab,
    BottomLoading,
    NoWorksData,
    messagebox
  },
  computed: {
    ...mapGetters({
      noMoreWorkList: "home/noMoreWorkList",
      worksList: "home/worksList",
      indexNavigations: "activityInfo/indexNavigations",
      activityName: "activityInfo/activityName",
      scrollTop: "home/scrollTop",
      activityCategorys: "activityInfo/activityCategorys"
    }),
    showNoWorkData() {
      return this.worksList.length < 1
    },
    noDataText() {
      return this.worksListSearchOptions.keyword !== "" ? "无匹配结果" : "快来为你的家乡点赞"
    }
  },
  watch: {
    showMask() {
      // this.handleToggleLockScroll(newVal)
    }
  },
  mounted() {
    this.initScrollEvent()
  },
  async created() {
    this.init()
    buryingPoint_home()
  },
  activated() {
    this.initShareInfo()
    this.setScrollTop()
  },
  beforeRouteLeave(to, from, next) {
    this._saveScrollTop()
    next()
  }
}
</script>

<style lang="scss" scoped>
.home-wrapper {
  height: 100%;
  width: 100%;
  overflow: auto;
  .banner {
    position: relative;
    z-index: 99;
  }
  .search-tab {
    position: sticky;
    top: 0;
    z-index: 100;
  }
  .mask {
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    &.transparent {
      position: absolute;
      background: transparent;
    }
  }
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease-in-out;
}
.fade-enter-to,
.fade-leave {
  opacity: 1;
}
</style>
